import {
    INTERVIEW_SET_TYPES,
    INTERVIEW_SET_CATEGORIES
} from '../constants/interview.constant.js';
import {getConfirmOnBehalfModalController} from "../confirm-on-behalf-modal/confirm-on-behalf.modal.js";

(function () {

    function InterviewStatusModalController($scope, modalData, sendNewInterviewInvite, InterviewFactory, withdrawInterview, onConfirmedInterviewOnBehalf, onAttendanceUpdated, amsBus, userPermissions, $modal) {
        const self = this;
        var _AMSDataManager,
            cardInfo;
        $scope.interviewType = modalData.interviewType;
        $scope.INTERVIEW_SET_TYPES = INTERVIEW_SET_TYPES;
        $scope.INTERVIEW_SET_CATEGORIES = INTERVIEW_SET_CATEGORIES;
        $scope.confirmedOnBehalf = modalData.selectedCardData.confirmedOnBehalf;
        self.actions = InterviewV2API.attendanceActions;

        if (amsBus.isAMSInitialized) {
            _AMSDataManager = amsBus._AMSDataManager;
            cardInfo = _AMSDataManager.getCardsFromAppIds([modalData.appId]);
        }

        if (cardInfo && cardInfo[modalData.appId]) {
            var location = cardInfo[modalData.appId].data.location || {};

            $scope.candidate = {
                name: cardInfo[modalData.appId].data.name,
                user_id: cardInfo[modalData.appId].data.id,
                profile_image: {
                    uuid: cardInfo[modalData.appId].data.profileImageUUID
                },
                phone: cardInfo[modalData.appId].data.phone,
                location: location.city
            }
        } else {
            AMSAPI.getApplicants(modalData.jobId, [modalData.appId])
                .then(function (data) {

                    var location = data[0].location.find(function (loc) {
                        return loc.UserLocation.is_primary;
                    }) || data[0].location[0] || {};

                    $scope.candidate = {
                        name: data[0].name,
                        user_id: data[0].candidate_id,
                        profile_image: {
                            uuid: data[0].profile_image_id
                        },
                        phone: data[0].phone,
                        location: location.UserLocation && location.UserLocation.formatted_address
                    };

                    $scope.$digest();
                });
        }

        $scope.editInvite = function () {
            $scope.sendNewInvite(true);
        };

        $scope.sendNewInvite = function (withoutWithdraw) {
            /*
            * Here where the code should be to open the send invite model in the interview status modal.
            * */
            sendNewInterviewInvite(modalData.appId, withoutWithdraw);
            $scope.$hide();
        };

        $scope.withdraw = function () {

            if (!$scope.loading) {

                $scope.loading = true;

                InterviewV2API.withdrawInterview(modalData.brandId, modalData.jobId, [modalData.appId], $scope.interviewType)
                    .then(function (res) {

                        if (res && res.succeded && res.succeded.length && res.succeded.indexOf(parseInt(modalData.appId)) > -1) {
                            withdrawInterview(modalData.appId);
                            $scope.loading = false;
                            $scope.$hide();
                            $scope.$digest();
                        }
                        else {
                            $scope.loading = false;
                            $scope.$digest();
                        }

                    }, function (err) {

                        $scope.loading = false;
                        $scope.$digest();
                    });
            }
        };

        self.confirmOnBehalf = async () => {
            let timeZones = null;
            try {
                timeZones = await InterviewFactory.getBrandTimeZoneDetails(modalData.brandId);
            } catch (err) {
                console.error('Failed to get brand time zone details:', err);
            }

            const confirmModalData = {
                appId: $scope.appDetails.application_id,
                interviewSetId: $scope.appDetails.interview_set.id,
                interviewType: $scope.interviewType,
                brandId: modalData.brandId,
                jobId: modalData.jobId,
                timeZones,
                onEditInvite: () => {
                    $scope.editInvite()
                },
            };

            const onSave = () => {
                return async () => {
                    const applicationStatus = await InterviewV2API.getApplicationStatusDetails(modalData.brandId, modalData.jobId, modalData.appId, $scope.interviewType);

                    onConfirmedInterviewOnBehalf(modalData.appId, applicationStatus);
                    $scope.$hide();
                    $scope.$digest();
                };
            };

            $modal(getConfirmOnBehalfModalController(confirmModalData, onSave));
        };

        self.handleAttendanceChange = async (action) => {
            self.loading = true;

            if (!$scope.appDetails || !$scope.appDetails.interview_set_slot) {
                self.loading = false;
                return;
            }

            const brandId = modalData.brandId;
            const jobId = modalData.jobId;
            const interviewSetId = $scope.appDetails.interview_set.id;
            const applicationId = $scope.appDetails.application_id;

            if (action === self.actions.CHECK_IN) {
                try {
                    await InterviewV2API.updateInterviewSetAttendance(brandId, jobId, interviewSetId, applicationId, action);
                    self.attendance = action;
                    onAttendanceUpdated(applicationId, self.attendance);
                } catch (err) {
                    console.error(err);
                    if (err?.data?.errors?.[0]?.detail) {
                        hAlert({
                            title: $filter("translate")("Attendance Update Failed"),
                            text: $filter("translate")("You can only update attendance within 24 hours after the interview time."),
                            custom_class: 'attendance-update-error-alert',
                            button: { text: $filter("translate")("Done") }
                        });
                    }
                } finally {
                    self.loading = false;
                    $scope.$hide();
                    $scope.$digest();
                }
            } else if (action === self.actions.NO_SHOW) {
                hConfirm({
                    text: $filter("translate")("Were you notified?"),
                    confirmButton: $filter("translate")("Yes"),
                    cancelButton: $filter("translate")("No"),
                    callback: async function (confirmed) {
                        const finalAction = confirmed
                            ? self.actions.NO_SHOW_NOTIFIED
                            : self.actions.NO_SHOW_NOT_NOTIFIED;

                        try {
                            await InterviewV2API.updateInterviewSetAttendance(brandId, jobId, interviewSetId, applicationId, finalAction);
                            self.attendance = finalAction;
                            onAttendanceUpdated(applicationId, self.attendance);
                        } catch (err) {
                            console.error(err);
                            if (err?.data?.errors?.[0]?.detail) {
                                hAlert({
                                    title: $filter("translate")("Attendance Update Failed"),
                                    text: $filter("translate")("You can only update attendance within 24 hours after the interview time."),
                                    custom_class: 'attendance-update-error-alert',
                                    button: { text: $filter("translate")("Cancel") }
                                });
                            }
                        } finally {
                            self.loading = false;
                            $scope.$hide();
                            $scope.$digest();
                        }
                    }
                });
            }
        };

        let init = () => {
            userPermissions.getBrandPolicy(modalData.brandId)
                .then((response) => {
                    const policyParser = response;
                    $scope.canManageInterviewTemplates = policyParser.has(userPermissions.PERMISSIONS.MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS);
                    self.canManageCandidate = policyParser.has(userPermissions.PERMISSIONS.MANAGE_JOB_CANDIDATES);
                    $scope.$digest();
                }).catch((err) => {
                    console.error(err);
                });
        };

        init();

        (function () {
            InterviewV2API.getApplicationStatusDetails(modalData.brandId, modalData.jobId, modalData.appId, $scope.interviewType)
                .then(function (response) {

                    $scope.appDetails = response;
                    $scope.appDetails.showActions = moment($scope.appDetails?.interview_set_slot?.start_time).startOf('day').isBefore();
                    self.attendance = $scope.appDetails.attendance;
                    self.isAttendanceChangeAllowed = !$scope.appDetails.attendance_details || $scope.appDetails.attendance_details?.attendance_change_count < $scope.appDetails.attendance_details?.max_attendance_change_count;
                    self.hasAttendanceHistory = !!$scope.appDetails.attendance;
                    self.isWithin24HoursAfter = moment().isBefore(moment($scope.appDetails?.interview_set_slot?.start_time).add(24, 'hours')) || !self.hasAttendanceHistory;
                    $scope.$digest();
                });
        })();

        $scope.INTERVIEW_STATUSES = InterviewV2API.INTERVIEW_STATUSES;
    }

    angular.module("harriApp")
        .controller("InterviewStatusModalController", [
            '$scope',
            'modalData',
            'sendNewInterviewInvite',
            'InterviewFactory',
            'withdrawInterview',
            'onConfirmedInterviewOnBehalf',
            'onAttendanceUpdated',
            'amsBus',
            'userPermissions',
            '$modal',
            InterviewStatusModalController
        ]);
})();